module.exports = __webpack_public_path__ + "media/img/features/dashboard-large-4516c1188e802623069804cc82866ff6.png";